module.exports = __webpack_public_path__ + "order/img/AM.f3155111.svg";